/* Plot & Harvest product page (v2 3-10-2026): gallery + photo viewer, options, cut-to-size calculator, basket,
   mobile purchase bar, fit planner, tabs, spec highlight, question form checks */
(function () {
  'use strict';
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  function money(cents) { try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: CUR }).format(cents / 100); } catch (e) { return '£' + (cents / 100).toFixed(2); } }

  $$('[data-ph-pdp]').forEach(function (root) {
    /* ---------------- gallery ---------------- */
    var slides = $$('[data-gal-slide]', root), thumbs = $$('[data-gal-go]', root), cur = 0;
    var capEl = $('[data-gal-cap]', root), countEl = $('[data-gal-count]', root), galLive = $('[data-gal-live]', root);
    function go(i, say) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== cur; });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      var cap = slides[cur].getAttribute('data-cap') || '';
      if (capEl) { capEl.textContent = cap; capEl.hidden = !cap; }
      if (countEl) countEl.textContent = (cur + 1) + ' / ' + slides.length;
      if (say && galLive) galLive.textContent = 'Photo ' + (cur + 1) + ' of ' + slides.length + (cap ? ': ' + cap : '');
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-gal-go'), true); }); });
    $$('[data-gal-step]', root).forEach(function (b) { b.addEventListener('click', function () { go(cur + +b.getAttribute('data-gal-step'), true); }); });
    var main = $('.ph-gal__main', root), sx = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1), true); sx = null; });
    }
    go(0, false);

    /* photo viewer (native dialog: Esc closes, focus returns to the photo) */
    var lb = $('[data-lb]', root), lbImg = lb && $('[data-lb-img]', lb), lbCap = lb && $('[data-lb-cap]', lb), lbOpener = null, lbI = 0;
    function lbShow(i) {
      lbI = (i + slides.length) % slides.length;
      var s = slides[lbI];
      lbImg.src = s.getAttribute('data-full'); lbImg.alt = s.getAttribute('data-alt') || '';
      lbCap.textContent = (s.getAttribute('data-cap') || '') + (slides.length > 1 ? ' (' + (lbI + 1) + ' of ' + slides.length + ')' : '');
    }
    function lbClose() { if (!lb || !lb.open) return; lb.close(); document.documentElement.classList.remove('ph-lb-open'); go(lbI, false); var zb = slides[cur] && $('[data-gal-zoom]', slides[cur]); (zb || lbOpener) && (zb || lbOpener).focus(); }
    if (lb && lb.showModal) {
      $$('[data-gal-zoom]', root).forEach(function (b) {
        b.addEventListener('click', function () { lbOpener = b; lbShow(cur); lb.showModal(); document.documentElement.classList.add('ph-lb-open'); $('[data-lb-close]', lb).focus(); });
      });
      $('[data-lb-close]', lb).addEventListener('click', lbClose);
      $$('[data-lb-step]', lb).forEach(function (b) { b.addEventListener('click', function () { lbShow(lbI + +b.getAttribute('data-lb-step')); }); });
      lb.addEventListener('cancel', function (e) { e.preventDefault(); lbClose(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
      lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') lbShow(lbI + 1); else if (e.key === 'ArrowLeft') lbShow(lbI - 1); });
    } else {
      $$('[data-gal-zoom]', root).forEach(function (b) { b.disabled = true; });
    }

    /* ---------------- options → variant ---------------- */
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (e) {}
    var groups = $$('[data-opt]', root);
    var idIn = $('[data-variant-id]', root), priceEl = $('[data-price]', root), unitEl = $('[data-unit]', root), basisEl = $('[data-basis-line]', root);
    var add = $('[data-add]', root), askP = $('[data-ask-product]', root), availEl = $('[data-avail]', root);
    var sbar = $('[data-sbar]', root), sPrice = sbar && $('[data-sbar-price]', sbar), sSel = sbar && $('[data-sbar-sel]', sbar), sAdd = sbar && $('[data-sbar-add]', sbar);
    var unitTxt = unitEl ? unitEl.textContent : '';
    var current = variants.filter(function (x) { return idIn && String(x.id) === idIn.value; })[0] || variants[0];
    var adding = false;

    function chosen() {
      var o = current ? current.o.slice() : [];
      groups.forEach(function (g) { var c = $('input:checked', g); if (c) o[+g.getAttribute('data-opt')] = c.value; });
      return o;
    }
    function highlightSpecs() {
      var t = current ? current.t.toLowerCase() : '';
      $$('[data-spec-key]', root).forEach(function (c) { var k = c.getAttribute('data-spec-key'); c.classList.toggle('is-on', !!k && t.indexOf(k) >= 0); });
    }
    function setButtons() {
      var ok = current && current.a;
      var label = adding ? 'Adding…' : (ok ? 'Add to basket' : (current ? 'Sold out' : 'Unavailable'));
      [add, sAdd].forEach(function (b) { if (!b) return; b.disabled = !ok || adding; b.textContent = label; if (adding) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
    }
    function update() {
      var o = chosen();
      var v = variants.filter(function (x) { return x.o.every(function (val, i) { return val === o[i]; }); })[0];
      if (!v) { current = null; setButtons(); return; }
      current = v;
      if (idIn) idIn.value = v.id;
      if (availEl) availEl.hidden = !v.a;
      var c = groups.length === 1 ? $('input:checked', groups[0]) : null, b = c ? c.getAttribute('data-basis') : '';
      if (!calc && basisEl) { basisEl.hidden = !b; basisEl.textContent = b ? 'Set: ' + b : ''; }
      if (askP) askP.value = askP.value.replace(/\s*\(.*\)$/, '') + (v.t && v.t !== 'Default Title' && v.t !== 'Default' ? ' (' + v.t + ')' : '');
      if (v.m) { var k = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.m)); if (k >= 0) go(k, false); }
      highlightSpecs();
      refreshPrice();
      setButtons();
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    groups.forEach(function (g) { g.addEventListener('change', update); });
    highlightSpecs();

    /* ---------------- cut-to-size calculator (quantity = m²) ---------------- */
    var calcBox = $('[data-calc]', root), calc = !!calcBox;
    var inW = calc && $('[data-calc-w]', calcBox), inL = calc && $('[data-calc-l]', calcBox), maxM = calc ? (+calcBox.getAttribute('data-max') || 50) : 0;
    var qtyHidden = $('[data-calc-qty]', root);
    var pW = $('[data-prop-w]', root), pL = $('[data-prop-l]', root), pA = $('[data-prop-a]', root), pP = $('[data-prop-p]', root);
    function fieldErr(inp) {
      var raw = String(inp.value).trim(), n = Number(raw);
      if (raw === '') return 'Enter the ' + (inp === inW ? 'width' : 'length') + ' in whole metres.';
      if (!/^\d+$/.test(raw) || n < 1) return 'Use a whole number of metres, 1 or more.';
      if (n > maxM) return 'For more than ' + maxM + ' m, please ask us using the form below.';
      return '';
    }
    function showErr(inp, msg) {
      var p = inp.closest('.ph-calc__f'), e = p && $('[data-calc-err]', p);
      if (e) { e.textContent = msg; e.hidden = !msg; }
      if (msg) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid');
    }
    function calcState() {
      if (!calc) return null;
      var ew = fieldErr(inW), el = fieldErr(inL);
      if (ew || el) return { ok: false, ew: ew, el: el };
      var w = +inW.value, l = +inL.value;
      return { ok: true, w: w, l: l, a: w * l };
    }
    function refreshPrice() {
      if (!current) return;
      var st = calcState();
      if (calc && st && st.ok) {
        var total = current.c * st.a;
        priceEl.textContent = money(total);
        if (unitEl) unitEl.textContent = 'for ' + st.a + ' m²';
        basisEl.textContent = 'Your piece: ' + st.w + ' m × ' + st.l + ' m (' + st.a + ' m²). Priced ' + unitTxt + '.';
        if (sPrice) sPrice.textContent = money(total);
        if (sSel) sSel.textContent = st.w + ' m × ' + st.l + ' m · ' + st.a + ' m²';
      } else {
        priceEl.textContent = current.p;
        if (unitEl) unitEl.textContent = unitTxt;
        if (calc) basisEl.textContent = 'Enter a width and length to price your piece.';
        if (sPrice) sPrice.textContent = current.p;
        if (sSel) sSel.textContent = calc ? 'Choose your size' : (unitTxt || 'incl. VAT');
      }
    }
    if (calc) {
      [inW, inL].forEach(function (inp) {
        inp.addEventListener('input', function () { if (inp.getAttribute('aria-invalid')) showErr(inp, fieldErr(inp)); refreshPrice(); });
        inp.addEventListener('blur', function () { if (String(inp.value).trim() !== '') showErr(inp, fieldErr(inp)); });
      });
      $$('[data-calc-step]', calcBox).forEach(function (b) {
        b.addEventListener('click', function () {
          var inp = $('input', b.parentNode), n = (parseInt(inp.value, 10) || 0) + +b.getAttribute('data-calc-step');
          inp.value = Math.min(maxM, Math.max(1, n)); showErr(inp, ''); refreshPrice();
        });
      });
    }
    refreshPrice();

    /* ---------------- quantity (fixed products) ---------------- */
    var q = $('[data-qty-input]', root);
    $$('[data-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () { var n = (parseInt(q.value, 10) || 1) + +b.getAttribute('data-qty'); q.value = Math.max(1, n); });
    });
    if (q) q.addEventListener('change', function () { q.value = Math.max(1, parseInt(q.value, 10) || 1); });

    /* ---------------- add to basket (AJAX, normal submit as fallback) ---------------- */
    var form = $('[data-buy-form]', root), msg = $('[data-buy-msg]', root);
    function say(html, err) { msg.hidden = false; msg.className = 'ph-buy__msg' + (err ? ' is-err' : ''); if (err) msg.textContent = html; else msg.innerHTML = html; }
    function guideToCalc(st) {
      showErr(inW, st.ew); showErr(inL, st.el);
      var first = st.ew ? inW : inL;
      calcBox.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      first.focus({ preventScroll: true });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        if (adding || !current || !current.a) { e.preventDefault(); return; }
        if (calc) {
          var st = calcState();
          if (!st.ok) { e.preventDefault(); guideToCalc(st); say('Please enter your width and length first.', true); return; }
          qtyHidden.value = st.a;
          pW.value = st.w + ' m'; pL.value = st.l + ' m'; pA.value = st.a + ' m²';
          pP.value = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);   /* keeps every cut piece on its own basket line */
          [pW, pL, pA, pP].forEach(function (x) { x.disabled = false; });
        }
        if (!window.fetch || !window.FormData) return;     /* plain form post */
        e.preventDefault();
        adding = true; setButtons(); msg.hidden = true;
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return fetch(base + 'cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            var what = calc ? 'Your ' + pW.value + ' × ' + pL.value + ' piece is in your basket.' : 'Added to your basket.';
            say(what + ' <a href="' + base + 'cart">View basket</a>');
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ph-pdp', data: { itemCount: cart.item_count, source: 'ph-pdp' } } }));
          })
          .catch(function (err) { say((err && (err.description || err.message)) || 'Could not add this item. Please try again.', true); })
          .then(function () {
            adding = false; setButtons();
            if (calc) [pW, pL, pA, pP].forEach(function (x) { x.disabled = true; });
            if (sbar && !sbar.hidden && msg && !inView(msg)) msg.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          });
      });
    }

    /* ---------------- mobile purchase bar ---------------- */
    function inView(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < (window.innerHeight || 0); }
    var mq = window.matchMedia('(max-width: 989px)'), past = false, typing = false;
    function syncBar() {
      if (!sbar) return;
      var show = mq.matches && past && !typing && !document.documentElement.classList.contains('ph-lb-open');
      sbar.hidden = !show;
      root.style.paddingBottom = show ? sbar.offsetHeight + 'px' : '';
    }
    if (sbar && add && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { past = !en.isIntersecting && en.boundingClientRect.top < 0; });
        syncBar();
      }).observe(add);
      mq.addEventListener ? mq.addEventListener('change', syncBar) : mq.addListener(syncBar);
      root.addEventListener('focusin', function (e) { if (e.target.matches('input, textarea, select')) { typing = true; syncBar(); } });
      root.addEventListener('focusout', function () { typing = false; setTimeout(syncBar, 50); });
      sAdd.addEventListener('click', function () {
        if (calc) { var st = calcState(); if (!st.ok) { guideToCalc(st); return; } }
        if (form.requestSubmit) form.requestSubmit(add); else add.click();
      });
    }

    /* ---------------- fit planner ---------------- */
    var fit = $('[data-fit]', root);
    if (fit) {
      var T = +fit.getAttribute('data-table'), CW = +fit.getAttribute('data-cw'), CD = +fit.getAttribute('data-cd'), CL = +fit.getAttribute('data-clear');
      var fL = $('[data-fit-l]', fit), fD = $('[data-fit-d]', fit), svg = $('[data-fit-svg]', fit), out = $('[data-fit-verdict]', fit);
      var needL = 2 * CD + T, needD = Math.max(T, CW);
      var r1 = function (n) { return Math.round(n * 10) / 10; };
      var note = $('.ph-fit__note', fit);
      if (note) note.textContent = 'Laid out as: table in the middle, a chair either side. Seated footprint ' + r1(needL) + ' × ' + r1(needD) + ' cm; we allow a further ' + r1(CL) + ' cm at each end to get in and out.';
      var draw = function () {
        var L = Math.max(0, parseFloat(fL.value) || 0), D = Math.max(0, parseFloat(fD.value) || 0);
        var W = 400, H = 260, pad = 26;
        var spanL = Math.max(L, needL), spanD = Math.max(D, needD);
        var sc = Math.min((W - 2 * pad) / spanL, (H - 2 * pad) / spanD);
        var cx = W / 2, cy = H / 2, h = '';
        if (L && D) {
          h += '<rect x="' + (cx - L * sc / 2) + '" y="' + (cy - D * sc / 2) + '" width="' + L * sc + '" height="' + D * sc + '" fill="#faf7ee" stroke="#b9a77a" stroke-width="1.5" stroke-dasharray="6 5" rx="2"/>';
          h += '<text x="' + cx + '" y="' + (cy - D * sc / 2 - 8) + '" text-anchor="middle" font-size="11" fill="#5f675f" font-family="Inter, sans-serif">' + r1(L) + ' cm</text>';
          h += '<text x="' + (cx + L * sc / 2 + 6) + '" y="' + (cy + 4) + '" font-size="11" fill="#5f675f" font-family="Inter, sans-serif">' + r1(D) + '</text>';
        }
        var cw = CW * sc, cd = CD * sc, t = T * sc;
        h += '<rect x="' + (cx - t / 2 - cd) + '" y="' + (cy - cw / 2) + '" width="' + cd + '" height="' + cw + '" fill="#8fa898" rx="3"/>';
        h += '<rect x="' + (cx + t / 2) + '" y="' + (cy - cw / 2) + '" width="' + cd + '" height="' + cw + '" fill="#8fa898" rx="3"/>';
        h += '<circle cx="' + cx + '" cy="' + cy + '" r="' + t / 2 + '" fill="#1f3a2c"/>';
        svg.innerHTML = h;
        var cls = '', b, sTxt;
        if (L >= needL + 2 * CL && D >= needD) { b = 'Fits comfortably'; sTxt = 'Room for both chairs pulled out and space to stand up at each end.'; }
        else if (L >= needL && D >= needD) { cls = 'is-tight'; b = 'Fits, but it’s snug'; sTxt = 'The set fits with the chairs pulled out, but there’s less than ' + CL + ' cm at each end to get in and out.'; }
        else { cls = 'is-no'; b = 'Too small for the set'; sTxt = 'You need at least ' + r1(needL) + ' × ' + r1(needD) + ' cm with the chairs pulled out (' + r1(needL + 2 * CL) + ' cm long to stand up comfortably).'; }
        out.className = 'ph-fit__verdict ' + cls;
        $('b', out).textContent = b; $('span', out).textContent = sTxt;
      };
      fL.addEventListener('input', draw); fD.addEventListener('input', draw);
      draw();
    }

    /* ---------------- on-page tabs: highlight the section in view ---------------- */
    var links = $$('[data-tabs] a', root);
    if (links.length && 'IntersectionObserver' in window) {
      var map = {};
      links.forEach(function (a) { var id = a.getAttribute('href').slice(1), el = document.getElementById(id); if (el) map[id] = a; });
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          var a = map[e.target.id]; if (a) a.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
    }

    /* ---------------- question form: inline checks, then the normal contact post ---------------- */
    var ask = $('[data-ask-form]', root);
    if (ask) {
      var fields = $$('input[required], textarea[required]', ask);
      var check = function (inp) {
        var val = inp.value.trim(), bad = !val || (inp.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val));
        var er = document.getElementById(inp.getAttribute('aria-describedby'));
        if (er) { er.textContent = bad ? er.getAttribute('data-msg') : ''; er.hidden = !bad; }
        if (bad) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid');
        return !bad;
      };
      fields.forEach(function (inp) {
        inp.addEventListener('blur', function () { if (inp.value.trim() || inp.getAttribute('aria-invalid')) check(inp); });
        inp.addEventListener('input', function () { if (inp.getAttribute('aria-invalid')) check(inp); });
      });
      ask.addEventListener('submit', function (e) {
        var first = null;
        fields.forEach(function (inp) { if (!check(inp) && !first) first = inp; });
        if (first) { e.preventDefault(); first.focus(); return; }
        if (calc && askP) { var st = calcState(); if (st && st.ok) askP.value = askP.value.replace(/\s*\[.*\]$/, '') + ' [size entered: ' + st.w + ' m × ' + st.l + ' m]'; }
      });
    }
    var st0 = $('[data-ask-status]', root);
    if (st0) { var sec = st0.closest('.ph-qa'); if (sec) sec.scrollIntoView(); st0.focus({ preventScroll: true }); }
  });
})();
